import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";

export const usePaOrdersActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    async function getOrders(filters: any): Promise<any> {
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            cig: filters.cig ? filters.cig : undefined,
            cup: filters.cup ? filters.cup : undefined,
            orderId: filters.orderId ? filters.orderId : undefined,
            businessCode: filters.businessCode ? filters.businessCode : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        }

        let data = await GET("sm/cigorder", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getOrderById(id: string): Promise<any> {
        let data = await GET("sm/cigorder/" + id, true);
        return data?.result;
    }

    async function createOrder(payload: any) {
        return await POST("sm/cigorder/", payload, true)
    }

    async function updateOrder(payload: any) {
        return await PUT("sm/cigorder/", payload, true)
    }

    return {
        getOrders,
        getOrderById,
        createOrder,
        updateOrder
    }
}
